<div
  *ngIf="show"
  class="loader__container" 
  [ngClass]="customCss"
>
  <img src="../../assets/sti-preloader.svg"/>
</div>
